import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import deTranslations from './locales/de.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      de: {
        translation: deTranslations,
      },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'de'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      // Convert detected language codes to our supported languages
      convertDetectedLanguage: (lng: string) => {
        // If browser language starts with 'de' (German variants: de-DE, de-AT, de-CH, etc.), use German
        if (lng.toLowerCase().startsWith('de')) {
          return 'de';
        }
        // For all other languages, default to English
        return 'en';
      },
    },
  });

export default i18n;
